  (function () {
    var clocks = document.querySelectorAll('[data-nz-offer-clock]');
    if (!clocks.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      var txt = pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
      for (var i = 0; i < clocks.length; i++) clocks[i].textContent = txt;
    }
    tick();
    setInterval(tick, 1000);
  })();

  (function () {
    var boxes = document.querySelectorAll('[data-nz-countdown]');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        if (box.dataset.nzInit === '1') return;
        box.dataset.nzInit = '1';
        var hrs = box.querySelector('[data-nz-hrs]');
        var min = box.querySelector('[data-nz-min]');
        var sec = box.querySelector('[data-nz-sec]');
        var dateEl = box.querySelector('[data-nz-countdown-date]');
        function pad(n) { return n < 10 ? '0' + n : '' + n; }
        function tick() {
          var now = new Date();
          var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
          var diff = Math.max(0, Math.floor((end - now) / 1000));
          if (hrs) hrs.textContent = pad(Math.floor(diff / 3600));
          if (min) min.textContent = pad(Math.floor((diff % 3600) / 60));
          if (sec) sec.textContent = pad(diff % 60);
          if (dateEl) dateEl.textContent = now.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        }
        tick();
        setInterval(tick, 1000);
      })(boxes[i]);
    }
  })();

  (function () {
    var wraps = document.querySelectorAll('.nzh-gallery-wrap');
    for (var w = 0; w < wraps.length; w++) (function (wrap) {
      var g = wrap.querySelector('[data-nzh-gallery]');
      if (!g || g.dataset.nzhInit === '1') return;
      g.dataset.nzhInit = '1';
      var slides = g.querySelectorAll('img');
      if (slides.length < 2) return;
      var dots = wrap.querySelectorAll('[data-nzh-gallery-dots] .nzh-gallery__dot');
      var thumbs = document.querySelectorAll('[data-nz-thumb]');
      var prev = wrap.querySelector('[data-nzh-gallery-prev]');
      var next = wrap.querySelector('[data-nzh-gallery-next]');
      var current = -1;

      function goTo(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        try {
          g.scrollTo({ left: i * g.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
        } catch (err) {
          g.scrollLeft = i * g.clientWidth;
        }
      }
      function mark(i) {
        current = i;
        for (var d = 0; d < dots.length; d++) {
          if (d === i) dots[d].classList.add('is-active');
          else dots[d].classList.remove('is-active');
        }
        for (var t = 0; t < thumbs.length; t++) {
          var idx = parseInt(thumbs[t].getAttribute('data-nz-thumb'), 10);
          thumbs[t].setAttribute('aria-current', idx === i ? 'true' : 'false');
        }
        if (prev) prev.hidden = i <= 0;
        if (next) next.hidden = i >= slides.length - 1;
      }

      var ticking = false;
      g.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(g.scrollLeft / (g.clientWidth || 1));
          if (i !== current) mark(i);
        });
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      for (var t2 = 0; t2 < thumbs.length; t2++) {
        thumbs[t2].addEventListener('click', function () {
          var i = parseInt(this.getAttribute('data-nz-thumb'), 10);
          if (!isNaN(i)) goTo(i);
        });
      }

      if (window.MutationObserver) {
        var mo = new MutationObserver(function (recs) {
          for (var r = 0; r < recs.length; r++) {
            var el = recs[r].target;
            if (!el.hasAttribute('hidden')) {
              var i = parseInt(el.getAttribute('data-nz-main-media'), 10);
              if (!isNaN(i) && i !== current) goTo(i);
              break;
            }
          }
        });
        for (var s = 0; s < slides.length; s++) {
          mo.observe(slides[s], { attributes: true, attributeFilter: ['hidden'] });
        }
      }

      var start = 0;
      for (var s2 = 0; s2 < slides.length; s2++) {
        if (!slides[s2].hasAttribute('hidden')) { start = s2; break; }
      }
      mark(start);
      if (start > 0) goTo(start, false);
    })(wraps[w]);
  })();
/* Use-case circles: keep the tiles muted and looping, and only start them
   once they scroll into view so the page does not download four clips up front. */
(function () {
  function boot() {
    var vids = document.querySelectorAll('.nzh-usecase video');
    if (!vids.length) return;

    function start(v) {
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.playsInline = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < vids.length; i++) start(vids[i]);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e++) {
        var v = entries[e].target;
        if (entries[e].isIntersecting) start(v);
        else if (!v.paused) v.pause();
      }
    }, { rootMargin: '120px' });

    for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();